import React, { useEffect } from "react";
import Lottie from "lottie-react";
import animation1 from "../../Assets/imgNewUI/animation1.json";
import animation2 from "../../Assets/imgNewUI/animation2.json";
import { useSelector } from "react-redux";
const CustomLoader3 = () => {
  const clientMasterData = useSelector((state) => state.clientMasterReducer);
  const clientData = clientMasterData?.clientMasterData || [];

  const [firstFinish, setFirstFinish] = React.useState(true);
  // useEffect(() => {
  //   let timer = setTimeout(() => {
  //     setFirstFinish(false);
  //   }, 500);
  //   return () => {
  //     clearTimeout(timer);
  //   };
  // }, []);
  const [loaderFile1, setLoaderFile1] = React.useState();
  const [loaderFile2, setLoaderFile2] = React.useState();



  useEffect(() => {
    const loadAnimation = async (url, setAnimation, fallback) => {
      if (!url) {
        setAnimation(fallback);
        return;
      }
      try {
        if (url.endsWith('.json')) {
          // Use fetch for public/remote JSON files
          try {
            const response = await fetch(url);
            if (response.ok) {
              const data = await response.json();
              setAnimation(data);
            } else {
              setAnimation(fallback);
            }
          } catch {
            setAnimation(fallback);
          }
        } else {
          setAnimation(url);
        }
      } catch {
        setAnimation(fallback);
      }
    };

    const url1 = process.env.REACT_APP_CLIENT_IMAGE_URL + (clientData[0]?.loaderConfiguration?.loaderImageUrl1 || '');
    const url2 = process.env.REACT_APP_CLIENT_IMAGE_URL + (clientData[0]?.loaderConfiguration?.loaderImageUrl2 || '');

    if (clientData[0]?.loaderConfiguration?.loaderImageUrl1?.endsWith('.json')) {
      getLottieDuration(url1).then((duration) => {
        if (duration) {
          setTimeout(() => {
            setFirstFinish(false);
          }, duration * 1000);
        }
      });
      loadAnimation(url1, setLoaderFile1, animation1);
    } else {
      setLoaderFile1(url1);
    }
    // Only proceed with loaderImageUrl2 logic if it is available
    if (clientData[0]?.loaderConfiguration?.loaderImageUrl2) {
      if (clientData[0]?.loaderConfiguration?.loaderImageUrl2?.endsWith('.json')) {
        loadAnimation(url2, setLoaderFile2, animation2);
      } else {
        setLoaderFile2(url2);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [clientData]);

  const getLottieDuration = async (url) => {
    const response = await fetch(url);
    const data = await response.json();
    const { ip, op, fr } = data;
    if (typeof ip === "number" && typeof op === "number" && typeof fr === "number") {
      return (op - ip) / fr;
    }
    return null;
  }
  return (
    <>
      {clientData[0]?.loaderConfiguration?.loaderImageUrl1?.endsWith('.json') ? (
        <Lottie
          className="customLoader"
          animationData={clientData[0]?.loaderConfiguration?.loaderImageUrl2 ? (firstFinish ? loaderFile1 : loaderFile2) : loaderFile1}
          loop={true}
        />
      ) : (
        <img
          src={loaderFile1}
          alt="loader"
          className="customLoaderImage"
        />
      )}
    </>
  );
};



export default CustomLoader3;
